var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="cart_empty"> <div id="cart_submenu">  <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100842'] ))==null?'':__t)+
'</li> <li class="active">'+
((__t=( resources['X100845'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> </div> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="cart"> <table class="cart-contents"> <thead> <tr> <th class="hidden-xs">'+
((__t=( resources['X100857'] ))==null?'':__t)+
'</th> <th>'+
((__t=( resources['X100858'] ))==null?'':__t)+
'</th> <th>'+
((__t=( resources['X100859'] ))==null?'':__t)+
'</th> <th class="hidden-xs">'+
((__t=( resources['X100860'] ))==null?'':__t)+
'</th> <th>'+
((__t=( resources['X100861'] ))==null?'':__t)+
'</th> </tr> </thead> <tbody class="myrow" id="cartList"></tbody> </table> <table class="cart-summary"> <tbody> <tr> <td class="terms" style="width:100%"> </td> <td class="totals"> <table class="cart-totals" style=""> <tbody> <tr> <td id="cart_subTotal">'+
((__t=( resources['X100852'] ))==null?'':__t)+
'</td> <td class="price">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.SubTotal ))==null?'':__t)+
'</td> </tr> <tr id="cart_subTotalNoVat"> <td>'+
((__t=( resources['X100874'] ))==null?'':__t)+
'</td> <td class="price">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.SubTotalNoVat ))==null?'':__t)+
'</td> </tr> <tr> <td>'+
((__t=( resources['X100854'] ))==null?'':__t)+
'</td> <td class="price">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.SubTotalVat ))==null?'':__t)+
'</td> </tr> <tr> <td class="cart-total price">'+
((__t=( resources['X100855'] ))==null?'':__t)+
'</td> <td class="cart-total price">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.Total ))==null?'':__t)+
'</td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </div> <div class="cart-buttons clearfix"> <a class="btn btn-primary checkout" id="cart_btnOrder"><i class="fa fa-shopping-cart"></i>'+
((__t=( resources['X100851'] ))==null?'':__t)+
'</a> <a class="btn btn-default checkout" id="cart_btnShop"><i class="fa fa-arrow-left"></i>'+
((__t=( resources['X100856'] ))==null?'':__t)+
'</a> </div> </div> </section> </div>';
}
return __p;
};
